import { Section, Eyebrow, Heading, P, PullQuote } from "../Chapter";

export const Lost = () => (
    <Section>
        <Eyebrow>VII. The cost</Eyebrow>
        <Heading>And what it quietly cost</Heading>

        <P>But abundance changes the value of a thing.</P>
        <P delay={0.05}>
            When words became free, we began spending them carelessly. We send more than any
            generation in history and say less. A person today writes more words in a week than a
            Victorian letter-writer produced in a year, and almost none of it will be read twice.
        </P>
        <P delay={0.05}>
            The pause disappeared, and the pause was where the thinking happened. There used to be a
            gap between feeling something and sending it: the time it took to find paper, to write,
            to walk to the post office. That gap caught things. Anger cooled in it. Better sentences
            were found in it. Now there is no gap, and we send the first draft of everything.
        </P>

        <PullQuote>
            Nothing is kept. An inbox is not a tin box. No one will find our letters in an attic,
            because there is no attic and there are no letters.
        </PullQuote>

        <P>
            Handwriting is going. Not dramatically — quietly, the way skills go when nothing
            requires them. Most people reading this couldn't fill a page by hand without their
            fingers aching. Fewer and fewer have ever received anything written in someone's actual
            hand.
        </P>
        <P delay={0.05}>
            And we stopped waiting, which sounds like a pure gain until you notice that waiting was a
            form of attention. To wait a month for a reply is to hold someone in your mind for a
            month.
        </P>
    </Section>
);
